import React,{Component} from 'react';
import Alert from '../../../Helper/SimpleAlert/alert';
import {NativeSelect, Grid} from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import {TextField} from '@material-ui/core';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {createDeal, GetDeal,UpdateDeal,GetPotential, DeleteDeal} from '../../../Actions/dealActions';
import moment from 'moment';
import { DateTimePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import  './deals.css';
import CircularProgress from '@material-ui/core/CircularProgress';

const styles = theme => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  select: {
    width: '55px',
    padding: '10px',
    fontSize: '1.4em',
    border: '1px solid',
    borderColor: '#ccc'
  },
  textField: {
    fontSize: '15px',
    marginTop:'5px',
  },
  subheading: {
    fontSize: '1em',
    fontWeight:600,
  },
  btn:{
    float:'right',
    borderRadius:'12px',
    color:'white',
    textAlign:'center',
    fontSize:'1em'
  },
  err:{
    color:'red'
  },
  pickerFont:{
    fontSize:'1.4rem'
  },
    progress: {
        margin: 2,
        color:'#fff',
        fontWeight:500
    },
  picker:{
    fontSize:'1.4rem'
  }
});
class DealForm extends Component {
  constructor () {
    super();
    this.state = {
      deals: {
        BusinessDeal: {
          "DealID": null,
          "PlaceId": "",
          "Title": "",
          "Description": "",
          "EndDate": moment().utc().add(90,'days').format('MM/DD/YYYY hh:mm:ss A'),
          "NumberofDeals": "10",
          "EmailId": ""
        }
      },
      DId:null,
      responseCode: true,
      update: false,
      errmessage: [],
      showAlert: false,
      msg:"",
      enable:false,
      showSuccess:false
    }
  }

  componentDidMount () {
    const {user} = this.props;
    const {errmessage} = this.state;
    // console.log('------',this.props.Deal);
    // this.props.GetDeal(user.results.BusinessUser.PlaceID);
    // this.interval = setInterval(() => {
    //     this.props.GetDeal(user.results.BusinessUser.PlaceID);
    //   }, 300000
    // );
    // let dealData = this.props.Deal;
    // if (dealData) {
    //   if (dealData.BusinessDeal) {
    //     if (dealData.BusinessDeal.EndDate) {
    //       let endDate = moment(moment.utc(dealData.BusinessDeal.EndDate).toDate()).local().format('MM/DD/YYYY hh:mm:ss A');
    //       if ((this.validateDate(endDate))>0) {
    //         // dealData.BusinessDeal["EndDate"] = endDate;
    //         dealData.BusinessDeal["EmailId"] = this.props.user.results.AppUser.Email;
    //         dealData.BusinessDeal["PlaceId"] = this.props.user.results.BusinessUser.PlaceID;
    //         this.setState({deals: dealData}, () => {
    //           if (this.state.responseCode === true) {
    //             this.setState({update: true})
    //             this.props.dealsData(this.state.deals.BusinessDeal, this.props.user);
    //           }
    //         });
    //       }
    //     }
    //   }
    // }
    // else{
      let {BusinessDeal} = this.state.deals;
      // BusinessDeal["EndDate"] = moment().format('MM/DD/YYYY hh:mm A');
      BusinessDeal["EmailId"] = user.results.AppUser.Email;
      BusinessDeal["PlaceId"] = user.results.BusinessUser.PlaceID;
      if(this.props.deals.results){
        BusinessDeal["DealID"]=this.props.deals.results.BusinessDeal.DealID;
      }
      this.setState({deals: {BusinessDeal}},()=>{});

    errmessage["Title"] = "";
    errmessage["Description"] = "";
  }

  componentWillUnmount () {
    clearInterval(this.interval);
    this.setState({open: false});
  }
  componentWillReceiveProps (nextProps) {
    let dealData = nextProps.deals;
  
    if (dealData) {
      if (dealData.BusinessDeal !== null && Object.keys(dealData.BusinessDeal).length) {
        if (dealData.BusinessDeal.EndDate) {
          let endDate = moment(moment.utc(dealData.BusinessDeal.EndDate).toDate()).local().format('MM/DD/YYYY hh:mm:ss A');
          if ((this.validateDate(endDate))>0) {
            // dealData.BusinessDeal["EndDate"] = endDate;
            dealData.BusinessDeal["EmailId"] = this.props.user.results.AppUser.Email;
            dealData.BusinessDeal["PlaceId"] = this.props.user.results.BusinessUser.PlaceID;
            this.setState({deals: dealData}, () => {
              if (this.state.responseCode === true) {
                this.setState({update: true})
                this.props.dealsData(this.state.deals.BusinessDeal, this.props.user);
              }
            });
          }
          else {
            dealData.BusinessDeal["EmailId"] = this.props.user.results.AppUser.Email;
            dealData.BusinessDeal["PlaceId"] = this.props.user.results.BusinessUser.PlaceID;
            this.setState({deals: dealData});
          }
        }
      }
    }
  }

  validateDate = (endDate) => {
    let difference = moment(endDate).diff(moment().utc().format('MM/DD/YYYY hh:mm:ss A'), 'minutes');
   return difference;
  };

  resetState = () => {
    let {user}=this.props;
    this.setState({
      deals: {
        BusinessDeal: {
          'DealID': null,
          'PlaceId': user.results.BusinessUser.PlaceID,
          'Title': '',
          'Description': '',
          'EndDate': moment().utc().add(90,'days').format('MM/DD/YYYY hh:mm A'),
          'NumberofDeals': '10',
          'EmailId': user.results.AppUser.Email
        }
      }
    })
  };

  handleClick = (e) => {
    //console.log(this.props.deals.BusinessDeal.EndDate,this.state.deals.BusinessDeal.EndDate);
    let {errmessage} = this.state
    let {BusinessDeal} = this.state.deals
    if (e.target.innerText === 'SAVE') {
      if (this.validateTitle(BusinessDeal.Title)) {
        if ((this.validateDate(BusinessDeal.EndDate))>60) {
          if (errmessage['Title'] === '') {
            if (errmessage['Description'] === '') {
             // BusinessDeal['EndDate'] = moment(BusinessDeal.EndDate).utc().format('MM/DD/YYYY hh:mm:ss A')
              this.setState({enable:!this.state.enable});
                this.props.createDeal(this.state.deals).then((data) => {
                  if (data.results.ResponseCode === true) {
                    this.setState({responseCode: true,
                      showAlert:!this.state.showAlert,
                      showSuccess:!this.state.showSuccess,
                      msg:'Deals Added Successfully.',
                      enable:!this.state.enable
                    });
                    this.props.dealsData(BusinessDeal, this.props.user)
                  }
                  else {
                    this.setState({responseCode: false})
                    this.setState({showSuccess:!this.state.showSuccess});
                    this.props.onError(true, 'Error in Deals Creation!. ');
                    this.resetState();
                  }
                })
            }
            else {
              this.props.onError(true, 'Description is not proper!. ')
              this.resetState();
            }
          }
          else {
            this.props.onError(true, 'Please enter valid Title!. ')
            this.resetState();
          }
        }
        else {
          this.props.onError(true, 'Expiry Date should be greater than current time by 1 Hour!. ')
          this.resetState();
        }
      }
      else {
        this.props.onError(true, 'Title cannot be blank!. ')
        this.resetState();
      }
    }
    else if (e.target.innerText === 'UPDATE') {
      if (this.validateTitle(BusinessDeal.Title)) {

        if (errmessage['Title'] === '') {
          if (errmessage['Description'] === '') {
            
            if (moment(BusinessDeal.EndDate).diff(moment(this.props.deals.BusinessDeal.EndDate).format('MM/dd/yyyy hh:mm:ss a'), 'minutes') !== 0)
            {
              if ((this.validateDate(BusinessDeal.EndDate)) > 60) {
                this.setState({enable:!this.state.enable});
                  this.props.UpdateDeal(this.state.deals).then((data) => {
                    if (data.results.ResponseCode === true) {
                      this.setState({showAlert:!this.state.showAlert,
                        showSuccess:!this.state.showSuccess,
                        msg:"Deals Updated successfully."
                      })
                      this.props.dealsData(BusinessDeal, this.props.user)
                    }
                    else {
                      this.setState({showSuccess:!this.state.showSuccess})
                      this.props.onError(true, 'Error in Deals Update!. ')
                    }
                  })
              }
              else {
                this.props.onError(true, 'Expiry Date should be greater than current time by 1 Hour!. ')
                // this.props.onUpdate();
              }
            }
            else {
                this.props.UpdateDeal(this.state.deals).then((data) => {
                  if (data.results.ResponseCode === true) {
                    this.setState({showAlert:!this.state.showAlert,
                      msg:"Deals Updated successfully.",
                      showSuccess:!this.state.showSuccess,})
                    this.props.dealsData(BusinessDeal, this.props.user)
                  }
                  else {
                    this.setState({showSuccess:!this.state.showSuccess})
                    // this.props.onUpdate();
                    this.props.onError(true, 'Error in Deals Update!. ')
                  }
                })
            }
          }
          else {
            this.props.onError(true, errmessage['Description'])
            this.props.onUpdate();
          }
        }
        else {
          this.props.onError(true, 'Please enter valid Title!. ')
          // this.props.onUpdate();
        }
      }
      else {
        this.props.onError(true, 'Title cannot be blank!. ')
        // this.props.onUpdate();
      }
    }
  };

  handleEndDate=(date)=>{
      const { BusinessDeal } = this.state.deals;
      BusinessDeal["EndDate"]=moment(date).utc().format('MM/DD/YYYY hh:mm:ss A')
      this.setState({deals:{BusinessDeal}});
  };

  validateTitle=(val)=>{
    const titlePattern = /^(?![0-9._, ]*$)[a-zA-Z0-9._$%^&*(){}[,'":/@+=; ]+$/;
    if(!titlePattern.test(val))
        return false;
    else
      return true;
  };

  handleChange=(e)=>{
    let {name,value}=e.target;
    let {errmessage}=this.state;
    let {BusinessDeal}=this.state.deals;
    const titlePattern =/^(?![0-9._, ]*$)[a-zA-Z0-9._$%^&*(){}[,'":/@+=; ]+$/;
    if(name==="Title") {
      if(value!=="") {
        if (value.length > 20) {
          errmessage[name] = 'Title Length should not be greater than 20 characters'
          this.setState({errmessage});
        }
        else if (!titlePattern.test(value)) {
          errmessage[name] = "Title should atleast contain alphabet or number ";
          this.setState({errmessage});
        }
        else{
          errmessage[name] = ""
          this.setState({errmessage});
        }
      }
      else{
        errmessage[name] = ""
        this.setState({errmessage});
      }
    }
    else if(name==="Description") {
      if (value!=="") {
        if (value.length > 50) {
          errmessage[name] = 'Description Length should not be greater than 50 characters'
          this.setState({errmessage});
        }
        else if (!titlePattern.test(value)) {
          errmessage[name] = "Description should atleast contain alphabet or number ";
          this.setState({errmessage});
        }
        else {
          errmessage[name] = "";
          this.setState({errmessage});
        }
      }
      else {
        errmessage[name] = "";
        this.setState({errmessage});
      }
    }
    BusinessDeal[name]=value;
    this.setState({deals:{BusinessDeal}});
  };
  alertCallback=()=>{
    this.setState({showAlert:!this.state.showAlert})
  };

  handleDelete = () => {
    let {BusinessDeal} = this.state.deals;
    this.setState({enable:!this.state.enable});
    this.props.DeleteDeal(BusinessDeal.DealID).then((data) => {
      if (data.results.ResponseCode === true) {

        this.setState({responseCode: true,
          showAlert:!this.state.showAlert,
          showSuccess:!this.state.showSuccess,
          msg:'Deal Deleted Successfully.',
          enable:!this.state.enable,
          update: false
        });
        this.resetState();
        this.props.dealsData({}, this.props.user);
      }
      else {
        this.setState({responseCode: false});
        this.setState({showSuccess:!this.state.showSuccess});
        this.props.onError(true, 'Error in Deals Deletion!. ');
        this.resetState();
      }
    });
  };

  render(){
    let { classes, potentialData }=this.props;
    let {update,errmessage}=this.state;
    let {BusinessDeal}=this.state.deals;
  
    return(
      <Grid container spacing={24}>
        <Alert onClose={this.alertCallback} showSuccess={this.state.showAlert} showError={false} Msg={this.state.msg}/>
      <Grid item sm={6}>
          <TextField
            label="1. Enter Deal Title"
            inputProps={{
              className:classes.textField
            }}
            InputLabelProps={{
              shrink: true,
              className:"label-text"
            }}
            value={BusinessDeal && BusinessDeal.Title}
            fullWidth
            margin="normal"
            name="Title"
            onChange={this.handleChange}
            FormHelperTextProps={{
              className:classes.subheading
            }}
            onBlur={this.validate}
            helperText={'Ex. $5 OFF'}
          />
        <div className={classes.err}>{errmessage['Title']}</div>
      </Grid>
        <div className="potential-button-deals">
          <span>Your Deal Has <br/>Potential Reach <br/>
            of {(!potentialData.results.countReceived)?
            <CircularProgress size={15} className={classes.progress}/>
            :
            potentialData.results.Count
                } People
          </span>
        </div>
      <Grid item sm={6} className="potential-grid-deals">

      </Grid>
      <Grid item sm={6}>
        <TextField
          name="Description"
          value={BusinessDeal.Description}
          label="2. Enter Deal Description"
          inputProps={{
            className:classes.textField
          }}
          InputLabelProps={{
            shrink: true,
            className:"label-text"
          }}
          FormHelperTextProps={{
            className:classes.subheading
          }}
          fullWidth
          margin="normal"
          onChange={this.handleChange}
          helperText={'Ex. Any purchase of $20 or more.'}
        />
        <div className={classes.err}>{errmessage['Description']}</div>
      </Grid>
        <Grid item sm={6}/>
      <Grid item sm={6}>
        <div className="form-label">{'3. Enter Deal expiration Date'}</div>
        <div className={"date-time"}>
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <DateTimePicker
              fullWidth
              color={'secondary'}
              margin={'normal'}
              InputProps={{
                className: classes.pickerFont,
              }}
              className={classes.picker}
              onError={console.log}
              minDate={moment().format('yyyy-MM-dd')}
              value={moment.utc(BusinessDeal.EndDate).local().format('MM/DD/YYYY hh:mm:ss A')}
              onChange={this.handleEndDate}
              format="MM/dd/yyyy hh:mm a"
              disableOpenOnEnter
              mask={[/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, ':', /\d/, /\d/, ' ', /a|p/i, 'M']}
            />
          </MuiPickersUtilsProvider>
        </div>
      </Grid>
      <Grid item sm={6}>
        <div className="form-label">{'4. Number of deals available to claim'}</div>
        <div>
          <NativeSelect
            name="NumberofDeals"
            onChange={this.handleChange}
            inputProps={{
              className:classes.select
            }}
            value={BusinessDeal.NumberofDeals}
          >
            <option value={10} >10</option>
            <option value={50}>50</option>
            <option value={100}>100</option>
            <option value={300}>300</option>
            <option value={500}>500</option>
          </NativeSelect>
        </div>
      </Grid>
      <Grid item sm={6}>
        <div className='overview-text'>{`${BusinessDeal.DealClaimed ?BusinessDeal.DealClaimed:0} Deals Claimed`}</div>
      </Grid>
      <Grid item sm={6}>
        { update &&<button className="deal-btn"
                onClick={this.handleDelete}
        >
          DELETE
        </button>}
        <button className="deal-btn"
                onClick={this.handleClick}
        >
          {update?"UPDATE":"SAVE"}
        </button>
      </Grid>
        {/*{ update &&*/}
          {/*<Grid item sm={3}>*/}
          {/*</Grid>*/}
        {/*}*/}
    </Grid>);
  }
}
const mapStateToProps=(state)=> {
  return {
    deals:state.deals.results,
    user:state.loginResponse
  }
};
const matchDispatchToProps=(dispatch)=> {
  return bindActionCreators({
    createDeal,
    GetDeal,
    UpdateDeal,
    GetPotential,
    DeleteDeal
  },dispatch)
};

export default withStyles(styles)(connect(mapStateToProps,matchDispatchToProps)(DealForm));
